import { defineMessages } from 'react-intl'

export const PROFILE_INJURY = {
  NONE: 'NONE',
  BACK: 'BACK',
  KNEE: 'KNEE',
  SHOULDER: 'SHOULDER',
  OTHER: 'OTHER'
}

export const PROFILE_INJURIES = Object.values(PROFILE_INJURY)

const labels = defineMessages({
  none: {
    id: 'ProfileInjury.none',
    defaultMessage: 'No injuries',
    description: 'User reports no injuries.'
  },
  back: {
    id: 'ProfileInjury.back',
    defaultMessage: 'Back injury',
    description: 'User has a back-related injury.'
  },
  knee: {
    id: 'ProfileInjury.knee',
    defaultMessage: 'Knee injury',
    description: 'User has a knee-related injury.'
  },
  shoulder: {
    id: 'ProfileInjury.shoulder',
    defaultMessage: 'Shoulder injury',
    description: 'User has a shoulder-related injury.'
  },
  other: {
    id: 'ProfileInjury.other',
    defaultMessage: 'Other injury',
    description: 'User has another type of injury not listed.'
  }
})

export const PROFILE_INJURY_MESSAGE = {
  [PROFILE_INJURY.NONE]: labels.none,
  [PROFILE_INJURY.BACK]: labels.back,
  [PROFILE_INJURY.KNEE]: labels.knee,
  [PROFILE_INJURY.SHOULDER]: labels.shoulder,
  [PROFILE_INJURY.OTHER]: labels.other
}

export const PROFILE_INJURY_EMOJI = {
  [PROFILE_INJURY.NONE]: '✅',
  [PROFILE_INJURY.BACK]: '🔙',
  [PROFILE_INJURY.KNEE]: '🦵',
  [PROFILE_INJURY.SHOULDER]: '💪',
  [PROFILE_INJURY.OTHER]: '❓'
}
